const OperatorType = Object.freeze({
  EQUALS: "=",
  NOT_EQUALS: "!=",
  GREATER: ">",
  GREATER_EQUALS: ">=",
  LESS: "<",
  LESS_EQUALS: "<=",
  CONTAINS: "∋",
  NOT_CONTAINS: "∌"
});
export default OperatorType;